import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import Dealer from 'models/dealerManagement/dealer/Model.Dealer';
import { useProductDealerDocumentProvider } from '../ProductDocument.DealerDocuments.Hooks';
import UploadDocumentTranslationButton from '../../../../components/translations/UploadDocumentTranslationButton';

export default function DealerDocumentList() {
  const { lang } = getLocales();
  const {
    dealerDocumentList,
    selectedItems,
    toggleItem,
    reloadTranslatedDocs,
    selectedTranslatedItems,
    toggleTranslatedItem,
    translatedDocumentList,
  } = useProductDealerDocumentProvider();

  return dealerDocumentList.count == 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.documents}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.dealer}</th>
          <th>{lang.document}</th>
          <th>{lang.translations}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={dealerDocumentList.data?.map((x) => ({ ...x, dealer: new Dealer(x.dealer) }))}
          render={({ data: productDealerDocument }) => {
            const isDocumentSelected = selectedItems?.some((it) => it.dealerId === productDealerDocument.dealerId);
            const translations =
              translatedDocumentList?.filter((it) => it.documentId === productDealerDocument.id) ?? [];
            const areTranslationsSelected = translations?.every((it) =>
              selectedTranslatedItems.some((t) => t.id === it.id)
            );
            return (
              <tr key={productDealerDocument.dealerId}>
                <td>
                  <b>{productDealerDocument.dealer.displayInfo.title}</b>
                </td>
                <td>{productDealerDocument.mediaFile?.name ?? '-'}</td>
                <td>
                  <UploadDocumentTranslationButton
                    documentId={productDealerDocument.id}
                    documentType="ProductDealerDocument"
                    translatedDocuments={translations}
                    onFinish={reloadTranslatedDocs}
                  />
                </td>
                <td>
                  <Box class={ThemeWrapperStack}>
                    <Button
                      data={productDealerDocument}
                      onClick={toggleItem}
                      class={ThemeButtonCircle}
                      media={<Icon class={isDocumentSelected ? 'fas-check-square' : 'far-square'} />}
                      render="EN"
                      htmlElementProps={{ title: isDocumentSelected ? lang.unselect : lang.select }}
                      active
                    />
                    <Button
                      data={translations}
                      onClick={toggleTranslatedItem}
                      class={ThemeButtonCircle}
                      disabled={isDocumentSelected || !translations?.length}
                      media={
                        <Icon
                          class={
                            (areTranslationsSelected || isDocumentSelected) && translations?.length
                              ? 'fas-check-square'
                              : 'far-square'
                          }
                        />
                      }
                      render="FR"
                      htmlElementProps={{ title: areTranslationsSelected ? lang.unselect : lang.select }}
                      active
                    />
                  </Box>
                </td>
              </tr>
            );
          }}
        />
      </tbody>
    </table>
  );
}
